import React, { useEffect, useState } from 'react';
import PageContainer from '../components/containers/PageContainer';
import Field from '../components/ui/Field';
import CustomTable from '../components/ui/CustomTable';
import { IconButton, TableCell, TableRow, Tooltip } from '@mui/material';
import { FileDownload } from '@mui/icons-material';
import api from '../config/axios';
import env from '../config/env';
import { toast } from 'react-toastify';

const Scans = () => {
    const [scans, setScans] = useState([]);
    const [order, setOrder] = useState({});
    const [loader, setLoader] = useState('');
    const [filter, setFilter] = useState('All');
    const [sort, setSort] = useState('asc');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [total, setTotal] = useState(0);
    const [url, setUrl] = useState('/admin/scans/read');
    const [search, setSearch] = useState('');

    useEffect(() => {
        getOrders();
    }, [page, sort, filter, limit, search]);

    const getOrders = async () => {
        var link = '';

        if (search !== '') {
            link =
                url + '?page=' + page + '&limit=' + limit + '&sort=' + sort + '&status=' + filter + '&search=' + search;
        } else {
            link = url + '?page=' + page + '&limit=' + limit + '&sort=' + sort + '&status=' + filter;
        }

        await api
            .get(link)
            .then((res) => {
                setScans(res.data.scans);
                setTotalPages(res.data.totalPages);
                setTotal(res.data.total);
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const downloadPdf = async (id) => {
        await api
            .get(`/scans/download/${id}`, env.downloadConfig)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'scan.pdf'); //or any other extension
                document.body.appendChild(link);
                link.click();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };
    return (
        <PageContainer title="View Scans" desc="All your Scans at one place">
            <Field
                placeholder="Search scan using  id, fromName, barcode"
                onChange={(e) => {
                    setSearch(e.target.value);
                }}
            />
            <CustomTable
                sx={{ mt: 2 }}
                fields={['Scan ID', 'USER', 'TOTAL', 'LABELTYPE', 'BARCODE', 'CREATED AT', 'ACTION']}
                dense={false}
                loading={loader}
                pagination
                count={totalPages}
                page={page}
                setPage={setPage}>
                {scans?.map((order, index) => (
                    <TableRow key={order._id}>
                        <TableCell>{order._id}</TableCell>
                        <TableCell>{order.user?.username}</TableCell>
                        <TableCell
                            sx={{
                                color: 'success.main',
                            }}>
                            ${order.price ? order.price.toFixed(2) : '0.00'}
                        </TableCell>
                        <TableCell>{order.scanType?.type}</TableCell>
                        <TableCell
                            sx={{
                                color: 'primary.main',
                            }}>
                            {order.scancode}
                        </TableCell>

                        <TableCell>{new Date(order.createdAt).toLocaleString()}</TableCell>
                        <TableCell>
                            <Tooltip title="Download Scan">
                                <IconButton
                                    onClick={() => {
                                        downloadPdf(order._id);
                                    }}>
                                    <FileDownload fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    </TableRow>
                ))}
            </CustomTable>
        </PageContainer>
    );
};

export default Scans;
